import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Teachings.css';
import card1 from '../card1.png';
import card2 from '../card2.png';
import card3 from '../card3.png';
import card4 from '../card4.png';

const Teachings = () => {
  const navigate = useNavigate();

  const handleReadMore = () => {
    // Navigate to VedaGurukulam page and scroll to Purpose Gallery Section
    navigate('/veda-gurukulam');
    // Use setTimeout to ensure the page loads before scrolling
    setTimeout(() => {
      const purposeSection = document.querySelector('.purpose-gallery-section');
      if (purposeSection) {
        purposeSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };

  const teachingCards = [
    {
      id: 1,
      image: card1,
      title: "Vedic Studies",
      description: "Learning of Vedas through oral chanting, pronunciation, and memorization as per sacred tradition."
    },
    {
      id: 2,
      image: card2,
      title: "Sanskrit & Shlokas",
      description: "Foundation in Sanskrit language and Vedic shlokas for accurate understanding and recitation."
    },
    {
      id: 3,
      image: card3,
      title: "Rituals & Samskaras",
      description: "Practical training in performing Samskaras, Homams, and sacred ceremonies as per scriptures."
    },
    {
      id: 4,
      image: card4,
      title: "Purohit Training",
      description: "Comprehensive training to prepare students to perform religious duties and serve society."
    }
  ];

  return (
    <section className="teachings-section">
      <div className="container">
        <div className="teachings-header">
          <div className="teachings-line"></div>
          <h2 className="teachings-title">What We Teach</h2>
        </div>
        
        <div className="teachings-subtitle">
          <h3>Vedic Knowledge & Teachings</h3>
          <p>At Sri Veda Gurukulam, students are trained in authentic Vedic knowledge through traditional learning methods that emphasize discipline, practice, and spiritual values.</p>
        </div>
        
        <div className="teachings-grid">
          {teachingCards.map((card) => (
            <div key={card.id} className="teaching-card">
              <div className="card-image">
                <img src={card.image} alt={card.title} />
              </div>
              <div className="card-content" style={{
                padding: '25px 20px',
                background: '#FFFFFF',
                position: 'relative',
                zIndex: 9999,
                display: 'block',
                visibility: 'visible',
                opacity: 1,
                minHeight: '150px'
              }}>
                <h4 className="card-title" style={{
                  fontFamily: 'Be Vietnam Pro, sans-serif',
                  fontSize: '20px',
                  fontWeight: '700',
                  color: '#2B0202',
                  margin: '0 0 15px 0',
                  letterSpacing: '0.5px',
                  display: 'block',
                  visibility: 'visible',
                  opacity: 1,
                  lineHeight: '1.3',
                  background: '#FFFFFF',
                  padding: '8px',
                  position: 'relative',
                  zIndex: 10000
                }}>{card.title}</h4>
                <p className="card-description" style={{
                  fontFamily: 'Be Vietnam Pro, sans-serif',
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '1.6',
                  color: '#555555',
                  margin: '0 0 20px 0',
                  display: 'block',
                  visibility: 'visible',
                  opacity: 1,
                  background: '#FFFFFF',
                  padding: '8px',
                  position: 'relative',
                  zIndex: 10000
                }}>{card.description}</p>
                <button 
                  className="read-more-btn" 
                  onClick={handleReadMore}
                  style={{
                    background: '#FFFFFF',
                    border: '2px solid #FF9900',
                    color: '#FF9900',
                    fontFamily: 'Be Vietnam Pro, sans-serif',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    display: 'inline-block',
                    visibility: 'visible',
                    opacity: 1,
                    position: 'relative',
                    zIndex: 10000,
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#FF9900';
                    e.target.style.color = '#FFFFFF';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#FFFFFF';
                    e.target.style.color = '#FF9900';
                  }}
                >Read More &gt;&gt;</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Teachings;